import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import ScrollToTop from './components/layout/ScrollToTop';
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import Home from './components/home/Home';
import Services from './components/services/Services';
import ServiceDetail from './components/services/ServiceDetail';
import Doctors from './components/doctors/Doctors';
import DoctorDetail from './components/doctors/DoctorDetail';
import About from './components/about/About';
import Contact from './components/contact/Contact';
import FAQ from './components/faq/FAQ';
import Fees from './components/fees/Fees';
import Blog from './components/blog/Blog';
import BlogDetail from './components/blog/BlogDetail';
import BulkBilling from './components/bulk-billing/BulkBilling';
import AfterHours from './components/after-hours/AfterHours';
import './styles/App.css';

function App() {
  return (
    <HelmetProvider>
      <div className="app">
        <ScrollToTop />
        <Header />
        <main className="main-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/services/:serviceId" element={<ServiceDetail />} />
            <Route path="/doctors" element={<Doctors />} />
            <Route path="/doctors/:doctorId" element={<DoctorDetail />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/fees" element={<Fees />} />
            <Route path="/bulk-billing" element={<BulkBilling />} />
            <Route path="/after-hours" element={<AfterHours />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:id" element={<BlogDetail />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </HelmetProvider>
  );
}

export default App;
